module.exports = {
          srcSet: __webpack_public_path__ + "08c708f3bc75d3c9a154b1c0c5a0f451-20.png"+" 20w",
          images:[ {path: __webpack_public_path__ + "08c708f3bc75d3c9a154b1c0c5a0f451-20.png",width: 20,height: 21}],
          src: __webpack_public_path__ + "08c708f3bc75d3c9a154b1c0c5a0f451-20.png",
          toString:function(){return __webpack_public_path__ + "08c708f3bc75d3c9a154b1c0c5a0f451-20.png"},
          
          width: 20,
          height: 21
        }